import shaka from 'shaka-player';
import toUTF8 from 'containers/Player/utils/toUTF8';

/** Encode: DASH
 *  DRM: playready
 *  Provider: default
 */

export const DashPlayReadyRequestFilter = (type, request, media, deviceId) => {
  if (type !== shaka.net.NetworkingEngine.RequestType.LICENSE) return;
  let challenge;

  if (media.media.challenge) {
    challenge = JSON.parse(media.media.challenge);
  }
  request.body = new Uint8Array(
    toUTF8(
      JSON.stringify({
        token: challenge.token,
        device_id: deviceId,
        widevineBody: btoa(
          String.fromCharCode.apply(null, new Uint8Array(request.body)),
        ),
      }),
    ),
  ).buffer;
};

/** Encode: DASH
 *  DRM: fairplay
 *  Provider: default
 */

export const DashWideVineRequestFilter = (type, request, media, deviceId) => {
  if (type !== shaka.net.NetworkingEngine.RequestType.LICENSE) return;
  const challenge = JSON.parse(media.media.challenge)
  request.body = new Uint8Array(
    toUTF8(
      JSON.stringify({
        token:
          challenge.token ||
          JSON.parse(challenge?.['custom-data'])?.token ||
          '',
        device_id: deviceId,
        widevineBody: btoa(
          String.fromCharCode.apply(null, new Uint8Array(request.body)),
        ),
      }),
    ),
  ).buffer;
};

/** Encode: HLS
 *  DRM: fairplay
 *  Provider: default
 */

export const HLSFairPlayRequestFilter = (
  type,
  request,
  media,
  deviceId,
  contentId,
) => {
  if (type !== shaka.net.NetworkingEngine.RequestType.LICENSE) {
    return;
  }
  const originalPayload = new Uint8Array(request.body);
  const base64Payload = shaka.util.Uint8ArrayUtils.toBase64(originalPayload);
  const params = `spc=${base64Payload}&token=${
    JSON.parse(media.media.challenge).token
  }&device_id=${deviceId}&skd_payload=${contentId}`;
  request.uris = [media.media.server_url];
  request.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  request.body = params;
};

/** Encode: HLS
 *  DRM: fairplay
 *  Provider: default
 * content: Live
 */

export const HLSFairPlayRequestFilterLive = (
  type,
  request,
  media,
  deviceId,
  contentId,
) => {
  if (type !== shaka.net.NetworkingEngine.RequestType.LICENSE) {
    return;
  }
  const originalPayload = new Uint8Array(request.body);
  const base64Payload = shaka.util.Uint8ArrayUtils.toBase64(originalPayload);
  const params = `spc=${base64Payload}&token=${
    JSON.parse(media.media.challenge).token
  }&device_id=${deviceId}&skd_payload=${contentId}`;
  request.uris = [media.media.server_url];
  request.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  request.body = params;
};

/** Encode: DASH
 *  DRM: widevine
 *  Provider: HBO
 */

export const HBODashWideVineRequestFilter = (type, request, media, drmInfo) => {
  const keyIds = drmInfo ? Array.from(drmInfo.keyIds) : [];
  if (type === shaka.net.NetworkingEngine.RequestType.LICENSE) {
    request.uris[0] = request.uris[0].replace('GetLicense', 'GetCertificate');
    const cuDat = media.media.challenge.replace('{keyid}', keyIds[0]);
    request.headers['dt-custom-data'] = window.btoa(cuDat);
  }
};

/** Encode: DASH
 *  DRM: widevine
 *  Provider: HBO
 */

export const HBODashPlayReadyRequestFilter = (type, request, media, skdUri) => {
  if (type !== shaka.net.NetworkingEngine.RequestType.LICENSE) {
    return;
  }
  // TODO:
};

/** Encode: HLS
 *  DRM: fairplay
 *  Provider: HBO
 */

export const HBOHLSFairPlayRequestFilter = (type, request, media, skdUri) => {
  if (type !== shaka.net.NetworkingEngine.RequestType.LICENSE) {
    return;
  }

  const originalPayload = new Uint8Array(request.body);
  const data = shaka.util.Uint8ArrayUtils.toStandardBase64(originalPayload);
  const token = media.media.challenge;
  const licRequest = `<LicenseRequest xmlns="go:v6:interop"><PlaybackCtx><![CDATA[${data}]]></PlaybackCtx></LicenseRequest>`;
  const test2 = encodeURI(skdUri);
  const challenge1 = token.replace('skd://{skd}', test2);
  request.uris = [media.media.server_url];
  request.headers['Content-type'] = 'text/plain;charset=UTF-8';
  request.headers['dt-custom-data'] = window.btoa(challenge1);
  request.headers['X-Content-Transfer-Encoding'] = 'base64';
  request.body = licRequest;
};

/** Encode: HLS
 *  DRM: fairplay
 *  Provider: default
 */

export const HLSFairPlayResponseFilter = (type, response) => {
  if (type !== shaka.net.NetworkingEngine.RequestType.LICENSE) {
    return;
  }
  let responseText = shaka.util.StringUtils.fromUTF8(response.data);
  responseText = responseText.trim();
  if (
    responseText.substr(0, 5) === '<ckc>' &&
    responseText.substr(-6) === '</ckc>'
  ) {
    responseText = responseText.slice(5, -6);
  }
  response.data = shaka.util.Uint8ArrayUtils.fromBase64(responseText).buffer;
};

/** Encode: HLS
 *  DRM: fairplay
 *  Provider: HBO
 */

export const HBOHLSFairPlayResponseFilter = (type, response) => {
  console.log('response.data', response.data);

  if (type !== shaka.net.NetworkingEngine.RequestType.LICENSE) {
    return;
  }
  const responseText = shaka.util.StringUtils.fromUTF8(response.data);
  const { License } = JSON.parse(responseText);

  response.data = shaka.util.Uint8ArrayUtils.fromBase64(License).buffer;
};

export const HLSFairPlayResponseToolboxFilter = (
  type,
  request,
  media,
  skdUri,
) => {
  if (type !== shaka.net.NetworkingEngine.RequestType.LICENSE) {
    return;
  }
};

export const HLSFairPlayToolboxRequestFilter = (
  type,
  request,
  media,
  deviceId,
  contentId,
  certificate,
) => {
  if (type !== shaka.net.NetworkingEngine.RequestType.LICENSE) {
    return;
  }
  let challenge;
  if (media.media.challenge) {
    challenge = JSON.parse(media.media.challenge);
    for (const [key, value] of Object.entries(challenge)) {
      request.headers[key] = value;
    }
  }
  const spcUint8Array = new Uint8Array(request.body);
  // Slice to get only the actual data
  const spcArrayBuffer = spcUint8Array.slice().buffer;

  request.uris = [`${media.media.server_url}&assetId=${contentId}`];
  request.body = spcArrayBuffer;
};

export const DashWideVineToolboxRequestFilter = (
  type,
  request,
  media,
  deviceId,
) => {
  if (type !== shaka.net.NetworkingEngine.RequestType.LICENSE) return;
  let challenge;
  if (media.media.challenge) {
    challenge = JSON.parse(media.media.challenge);
    for (const [key, value] of Object.entries(challenge)) {
      request.headers[key] = value;
    }
  }
};
